import { FC, PropsWithChildren } from 'react';
import { decodeToken } from 'react-jwt';
import { AuthenticationResult } from '@azure/msal-browser';

import { FullscreenLoader } from '@components/base';
import { reverseName } from '@utils/stringUtils';

import { User } from '../types';

import UserContext from './context';

type AccessToken = {
  family_name: string;
  given_name: string;
  name: string;
  roles?: string[];
  unique_name: string;
};

type UserProviderProps = PropsWithChildren<{
  result: AuthenticationResult;
}>;

const UserProvider: FC<UserProviderProps> = ({ children, result: { accessToken } }) => {
  const decodedToken = decodeToken<AccessToken>(accessToken);

  const user: undefined | User = decodedToken
    ? {
        email: decodedToken.unique_name,
        firstName: decodedToken.given_name,
        lastName: decodedToken.family_name,
        roles: decodedToken.roles || [],
        name: reverseName(decodedToken.name),
      }
    : undefined;

  return accessToken && user ? (
    <UserContext.Provider value={user}>{children}</UserContext.Provider>
  ) : (
    <FullscreenLoader open />
  );
};

export default UserProvider;
